import React from 'react';
import MainBody from '../templates/MainBody';
import { geointContent } from '../data';

//go over google dorking techniques and examples

const GEOINT: React.FC = () => {
  return <MainBody data={geointContent} />;
};

export default GEOINT;